// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"ca57f546","384":"5d8be40c","453":"9799b89c","760":"b6152c0c","855":"b2383400","907":"e414c8c6"}[chunkId] + ".chunk.js";
};